import {
  ref
} from 'vue'

import { useAjax } from '@composables/useAjax.js'

const STORAGE_KEY_COUNTRY = 'my-country'

export const useIntlTel = (selector) => {
  const intlCountry = ref(null)
  const intlNumber = ref(null)

  const initializeIntlTel = (args = {}) => {
    const { country, phone } = args

    $(selector).intlTelInput({
      preferredCountries: ['us', 'jp', 'tw', 'gb', 'au', 'th', 'ca', 'hk', 'sg', 'cn', 'de', 'ph', 'in', 'id', 'fr', 'nl', 'nz', 'my', 'it', 'ru', 'es', 'br', 'kr', 'za', 'se'],
      utilsScript: '/plugins/intl-tel-input/utils.js'
    })

    if (country) {
      setCountry(country)
    }
    else {
      setCountryByIp()
    }

    if (phone) {
      intlNumber.value = phone
      $(selector).intlTelInput("setNumber", phone)
    }

    $(selector).on('countrychange', () => {
      intlCountry.value = $(selector).intlTelInput("getSelectedCountryData").iso2
    })

    $(selector).on('input', () => {
      const v = $(selector).intlTelInput("getNumber")
      intlNumber.value = typeof v == 'string' ? v : $(selector).val()
    })
  }

  const setCountry = (country) => {
    intlCountry.value = country
    $(selector).intlTelInput("setCountry", country)
  }

  const setCountryByIp = async () => {
    const storage = localStorage.getItem(STORAGE_KEY_COUNTRY)

    if (storage) {
      setCountry(storage)
    }

    const { callGet } = useAjax()
    const response = await callGet('/my_country.json')
    if (response && response.country) {
      const value = response.country.toLowerCase()
      setCountry(value)
      localStorage.setItem(STORAGE_KEY_COUNTRY, value)
    }
  }

  return {
    // variables
    intlCountry,
    intlNumber,
    // methods
    initializeIntlTel,
  }
}
